import React from 'react';
import PropTypes from "prop-types";
const PhotosMascotaHeader = ({title, imgUrl}) => {
    return (
        <div className="card_header-photos card_header_photos--vacunacion">
            <div className="card_header_vacunacion--left">
                <div className="card_header_icon-photos">
                        <i> <img src={imgUrl} alt="image-icon" /></i>
                </div>
                <div className="card_header_title-photos">
                        <span>{title}</span>
                </div>
            </div>
        </div>
    )
}
PhotosMascotaHeader.propTypes = {
    title: PropTypes.string.isRequired,  
    imgUrl: PropTypes.string.isRequired,  
}

export default PhotosMascotaHeader;



// WEBPACK FOOTER //
// ./src/home/photosMascotaHeader.js